<div class="pwa-notice"
     *ngIf="pwaNoticeIsVisible()">
  <div class="pwa-notice__intro">
    <strong class="d-block mb-0025">Action Builder</strong>
    <span class="d-block color--gray--03 d-none--sm">Add to Home Screen</span>
    <span class="d-none color--gray--03 d-block--sm">Save us to your home screen</span>
  </div>
  <div class="pwa-notice__actions">
    <button class="btn mr-0075"
            (click)="onOpenPWAModalClick()">
      <span class="txt-12 caps">Add</span>
    </button>
    <button class="btn btn--mat-white"
            (click)="onDismissPWANoticeClick()">
      <span class="d-none--sm">
        <i class="fal fa-xmark txt-16 color--gray--02"></i>
      </span>
      <span class="d-none d-inline--sm txt-12 caps color--gray--02">Dismiss</span>
    </button>
  </div>
</div>

<app-admin-header *ngIf="headerType === 'admin'"></app-admin-header>
<app-campaign-header *ngIf="headerType === 'campaign'"></app-campaign-header>
<app-header-no-tabs *ngIf="headerType === 'no_tabs'"></app-header-no-tabs>

<div class="skinny-nav-btn-wrap">
<button type="button"
        class="skinny-nav-btn"
        (click)="toggleSkinnyNav()">
  <i class="far fa-arrow-to-left"></i>
</button>
<label>
  <!-- placeholder / tooltip text -->
  <!-- avoiding matTooltip for now since its positioning doesn't follow this button when the nav shrinks/expands -->
</label>
</div>
